import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Message } from 'element-react';
import CommonDialog from '../../../../common/dialog'
import './index.scss';

class CardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardList: []
    }
  }

  render() {
    const { techDatas } = this.props;
    return (
      <div className="card_list">
        {
          techDatas.map((item) => {
            const dialogData = {
              type: 3,
              id: item.get('id'),
              title: item.get('name'),
              status: 1
            }
            return (
              <div className="card_list_box" key={item.get('id')}>
                <div className="card_list_box_img b_img">
                  <img src={item.get('logo')}></img>
                </div>
                <div className="card_list_box_content">
                  <h2 className="card_list_box_content_title">{item.get('name')}</h2>
                  <p className="card_list_box_content_tips">{item.get('en')}</p>
                  <p className="card_list_box_content_desc">{item.get('des')}</p>
                  
                  <div className="card_list_box_content_btn">
                    <CommonDialog dialogData={dialogData} />
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
}

const mapState = (state) => ({
  techDatas: state.getIn(['tech', 'cardList'])
});

export default connect(mapState, null)(CardList);